'use es6';

import PropTypes from 'prop-types';
const numberOrString = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
export default {
  customWidgetId: numberOrString
};